import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getSingleTypeDocument } from '../actions/prismic';
import { RootState } from '../reducers';
import { getSingleTypeDoc } from '../selectors/entities';
import { getSingleTypeDocError } from '../selectors/errors';
import { getSingleTypeDocLoader } from '../selectors/loaders';

const useSingleType = <T = any>(
  singleTypeId: string
): {
  data: T;
  error: any;
  loading: boolean;
} => {
  const dispatch = useDispatch();
  const data = useSelector<RootState, T>(
    getSingleTypeDoc(singleTypeId) as (state: RootState) => T
  );
  const error = useSelector(getSingleTypeDocError(singleTypeId));
  const loading = useSelector<RootState, boolean>(
    getSingleTypeDocLoader(singleTypeId) as (state: RootState) => boolean
  );

  useEffect(() => {
    if (!loading && !error && !data) {
      dispatch(getSingleTypeDocument(singleTypeId));
    }
  }, [dispatch, data, loading, error, singleTypeId]);

  return { data, error, loading };
};

export default useSingleType;
